module.exports = __webpack_public_path__ + "media/images/mamari/wowma/flow-bg-green-3b9ccc400ee74763b861854e866071cf.png";